<app-abstract-dialog [dialogWidth]="'800'">
    <h3 abstract-header class="abstract-dialog__header__title">{{'PROJECT.LANDING_PAGE.HEALTHBANK_POPUP_TITLE' | translate}}</h3>

    <ng-container abstract-content>
        <div class="abstract-dialog__content__image">
            <img src="{{image}}" alt="Image of health bank application on mobile phone">
        </div>
        <p class="abstract-dialog__content__text" [innerHTML]="'PROJECT.LANDING_PAGE.HEALTHBANK_POPUP_DESCRIPTION' | translate"></p>
    </ng-container>
</app-abstract-dialog>
